// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__c0RJP","summary":"CartItem_summary__EFq0B","price":"CartItem_price__nHb8X","amount":"CartItem_amount__ZEyBo","actions":"CartItem_actions__NXe5b"};